export const truncateWords = (words: string, length = 120): string => {
  return words.length > length ? words.slice(0, length) + '...' : words;
};
